import { render } from "./Tab1.vue?vue&type=template&id=607a1cdd"
import script from "./Tab1.vue?vue&type=script&lang=ts"
export * from "./Tab1.vue?vue&type=script&lang=ts"
script.render = render

export default script